import axios from 'axios';
import store from '../vuex/store'
import Vue from 'vue';
import routes from '../routes'
import { Notification, MessageBox, Message, Loading } from 'element-ui'

// 创建 Axios 实例
const service = axios.create({
  baseURL: '/prod-api/', //本地
  //baseURL: 'http://39.107.73.80:1000/', //线上
  timeout: 10000, // 请求超时时间
  withCredentials: false,
  changeOrigin:true
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如添加 token
    const token = store.state.token;
    if (token) {}
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做些什么
    const res = response.data;
	console.log(res,1122)
	if (res.code == 200) {
	  return res;
	}else if (res.code == 500) {
      // 处理业务错误
      Message({ message: res.msg, type: 'error' })
	  return Promise.reject(res);
    }else if (res.code == 401) {
      // 处理业务错误
      Message({ message: res.msg, type: 'error' })
	  return Promise.reject(res);
    } else {
      Message({ message: res.msg, type: 'error' })
	  return Promise.reject(res);
    }
  }.bind(new Vue()),
  (error) => {
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js